export const width = 1000;
export const height = 1000;
